













































































































import Vue from 'vue';
import { MetaInfo } from 'vue-meta';

export default Vue.extend({
  metaInfo(): MetaInfo {
    return { title: this.$t('pages.public.Imprint.meta.title').toString() };
  },
  mounted() {
    this.setBreadCrumb();
  },
  methods: {
    setBreadCrumb() {
      this.$store.commit('UiStoreModule/setBreadcrumbItems', [
        { to: { name: 'Home' }, translationKey: 'pages.public.Imprint.breadcrumb.last' },
      ]);
    },
  },
});
